import * as React from 'react'
import { graphql } from 'gatsby'
// import { Link, useStaticQuery, graphql } from 'gatsby'
// import { GatsbyImage } from 'gatsby-plugin-image'

import Layout from '../../components/Layout'
import Debug from '../../components/Debug'
import PageEvents from '../../components/PageEvents'
import Grid from '../../components/Grid'
import Tile from '../../components/Tile'
import PageHero from '../../components/PageHero'
import Headline from '../../components/Headline'
import Caption from '../../components/Caption'
import Heading from '../../components/Heading'

export const query = graphql`
  query SanityCollection($id: String!) {
    sanityCollection(id: { eq: $id }) {
      id
      name
      slug {
        current
      }
      promotions {
        abbreviation
        slug {
          current
        }
      }
      featuredEvents {
        id
        name
        slug {
          current
        }
        logo {
          asset {
            gatsbyImageData
          }
        }
      }
    }
    allSanityEvent(
      filter: { collections: { elemMatch: { id: { eq: $id } } } }
      sort: { fields: date, order: ASC }
    ) {
      nodes {
        id
        name
        slug {
          current
        }
        date(formatString: "MMMM D, YYYY")
        promotion {
          abbreviation
        }
        hidePromotion
        logo {
          asset {
            gatsbyImageData
          }
        }
        wallpaper {
          asset {
            gatsbyImageData
          }
        }
      }
    }
  }
`

export default function SanityCollection({ data }) {
  const collection = data.sanityCollection
  const events = data.allSanityEvent.nodes

  const randomEvent = events[Math.floor(Math.random() * events.length)]

  return (
    <Layout title={collection.name} modifier="collection">
      <PageHero>
        <Headline>{collection.name}</Headline>
        <Caption>
          {events[0].date.split(', ')[1]}-
          {events[events.length - 1].date.split(', ')[1]} • {events.length}
          {` `}
          {events.length > 1 ? `Events` : `Event`}
        </Caption>
      </PageHero>
      <PageEvents>
        <Heading>{collection.name} Events</Heading>
        <Grid>
          {events.map((event) => (
            <Tile key={event.id} event={event} />
          ))}
        </Grid>
      </PageEvents>
      <Debug hidden>
        <h1>{collection.name}</h1>

        <h2>Collection Info</h2>
        <pre>{JSON.stringify(collection, null, 2)}</pre>

        <h2>Events from {collection.name}</h2>
        <pre>{JSON.stringify(events, null, 2)}</pre>
      </Debug>
    </Layout>
  )
}
